import { Component, input } from "@angular/core";

@Component({
  selector: 'ChevronRight',
  standalone: true,
  template: `
    <svg
      [class]="class()"
      height="12"
      viewBox="0 0 12 12"
      width="12"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="m3 1 5 5-5 5"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
      />
    </svg>
  `,
})
export class ChevronRight {
  class = input('');
}
